import { defineComponent, onMounted, ref } from 'vue';
import '@/assets/less/common.less';
import CardIcon from '@/components/common/card-icon/index.vue';
import CusHeader from '@/components/common/header/index.vue';
// import NumShow from '@/components/common/num-show/index.vue';
import HttpRequest from '@/util/axios.config';
import SelectList from '@/components/common/select-list';
import SharePopup from '@/components/common/share-popup/index.vue';
import TimeTab from '@/components/common/time-tab/index.vue';
import { server } from '@/data/common';
import { useRouter } from 'vue-router';
import { formatNumber } from '@/methods/base';
import { getData, controlTimeType, subscribersMap, subscribersTrendMap, sitesMap, sitesTrendMap, appUsersMap, appUsersTrendMap, doorsMap, doorsTrendMap } from './util';
export default defineComponent({
    components: {
        CardIcon,
        CusHeader,
        // NumShow,
        SelectList,
        SharePopup,
        TimeTab
    },
    props: {
        type: {
            type: String,
            required: true
        },
        token: {
            type: String,
            default: ''
        }
    },
    setup(props) {
        const globalRef = ref(null);
        const headerRef = ref(null);
        const mapRef = ref(null);
        const router = useRouter();
        // 手动计算地图的高度
        onMounted(() => {
            if (globalRef.value !== null && headerRef.value !== null && mapRef.value !== null) {
                mapRef.value.style.height = `${globalRef.value.clientHeight - headerRef.value.clientHeight - 10}px`;
            }
        });
        const { disList, cardInfo, totalUserNum } = getData(props.type, props.token);
        // 获取头部相关信息
        const pageName = ref('');
        const serverList = ref([]);
        const getHeaderData = () => {
            HttpRequest.get('getConfig', props.token === '' ? {} : {
                Token: props.token
            }, (res) => {
                if (props.token !== '') {
                    pageName.value = res.data.token.Title === '' ? server[props.type] : res.data.token.Title;
                }
                else {
                    pageName.value = res.data.admin.pageName ? res.data.admin.pageName : server[props.type];
                }
                serverList.value = [{
                        label: 'Global',
                        value: 'global'
                    }];
                if (props.token === '') {
                    res.data.serverList.forEach((item) => {
                        serverList.value.push({
                            label: item.name,
                            value: item.code
                        });
                    });
                }
            });
        };
        getHeaderData();
        const showShareDialog = ref(false);
        const shareUrl = `http://120.78.142.208:1717/manage-new/#/server?type=${props.type}&token=`;
        const { timeType, setTimeType } = controlTimeType();
        // 切换总数/社区/办公统计数据-月租用户数
        const monthlyUserType = ref('subscribers');
        const { subscribersType, subscribersOptions } = subscribersMap();
        const selectMonthFeeUserFun = (type) => {
            monthlyUserType.value = type;
        };
        // 切换总数/社区/办公统计数据-项目数
        const siteNumType = ref('sites');
        const { sitesType, sitesOptions } = sitesMap();
        const selectSitesNumFun = (type) => {
            siteNumType.value = type;
        };
        // 切换项目总数/社区/办公-趋势图
        const sitesNumTrendType = ref('sitesTotalTrend');
        const { sitesTrendOptions, sitesTrendType } = sitesTrendMap();
        const selectSitesNumTrendFun = (type) => {
            sitesNumTrendType.value = type;
            setTimeType(timeType.value.sites, 'sites', sitesNumTrendType.value);
        };
        // 切换总数/社区/办公统计数据-door的relay数
        const doorNumType = ref('doors');
        const { doorsType, doorsOptions } = doorsMap();
        const selectDoorssNumFun = (type) => {
            doorNumType.value = type;
        };
        // 切换door总数/社区/办公-趋势图
        const doorsNumTrendType = ref('doorsTotalTrend');
        const { doorsTrendOptions, doorsTrendType } = doorsTrendMap();
        const selectDoorsNumTrendFun = (type) => {
            doorsNumTrendType.value = type;
            setTimeType(timeType.value.doors, 'doors', doorsNumTrendType.value);
        };
        // 切换apps总数/社区/办公-趋势图
        const appsNumTrendType = ref('appUsersTotalTrend');
        const { appUsersTrendOptions, appUsersTrendType } = appUsersTrendMap();
        const selectAppssNumTrendFun = (type) => {
            appsNumTrendType.value = type;
            setTimeType(timeType.value.apps, 'apps', appsNumTrendType.value);
        };
        // 切换总数/社区/办公统计数据-app用户数
        const userType = ref('appUsers');
        const { appUsersOptions, appUsersType } = appUsersMap();
        const selectAppUserFun = (type) => {
            userType.value = type;
        };
        // 切换订阅用户总数/社区/办公-趋势图
        const monthlySubscribersTrendType = ref('subscribersTotal');
        const { subscribersTrendOptions, subscribersTrendType } = subscribersTrendMap();
        const selectSubscribersTrendFun = (type) => {
            monthlySubscribersTrendType.value = type;
            setTimeType(timeType.value.subscribers, 'subscribers', monthlySubscribersTrendType.value);
        };
        // 跳转服务器页面
        const goToServerPage = (code) => {
            if (code === 'global') {
                router.push('/global');
            }
            else {
                router.replace(`/server?type=${code}`);
                monthlyUserType.value = 'subscribers';
                userType.value = 'appUsers';
                monthlySubscribersTrendType.value = 'subscribersTotal';
                getData(code, props.token);
                getHeaderData();
            }
        };
        // 跳转代理商页面
        const goToDisPage = (dis) => {
            router.push(`/dis?type=${dis}&server=${props.type}`);
        };
        return {
            disList,
            cardInfo,
            globalRef,
            headerRef,
            totalUserNum,
            mapRef,
            pageName,
            serverList,
            goToServerPage,
            goToDisPage,
            showShareDialog,
            shareUrl,
            timeType,
            setTimeType,
            formatNumber,
            subscribersType,
            subscribersOptions,
            selectMonthFeeUserFun,
            monthlyUserType,
            appUsersOptions,
            appUsersType,
            userType,
            selectAppUserFun,
            monthlySubscribersTrendType,
            subscribersTrendOptions,
            selectSubscribersTrendFun,
            subscribersTrendType,
            siteNumType,
            sitesType,
            sitesOptions,
            selectSitesNumFun,
            sitesNumTrendType,
            sitesTrendOptions,
            sitesTrendType,
            selectSitesNumTrendFun,
            doorNumType,
            doorsType,
            doorsOptions,
            selectDoorssNumFun,
            doorsNumTrendType,
            doorsTrendOptions,
            doorsTrendType,
            selectDoorsNumTrendFun,
            appsNumTrendType,
            appUsersTrendOptions,
            appUsersTrendType,
            selectAppssNumTrendFun
        };
    }
});
